/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Admin_Commission_Quarter_PayableInputs */



/**
* | output |
* | --- |
* | "{amount} payable" |
*
* @param {Partner_Admin_Commission_Quarter_PayableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_quarter_payable = /** @type {((inputs: Partner_Admin_Commission_Quarter_PayableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Quarter_PayableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} zahlbar`)
	return /** @type {LocalizedString} */ (`${i?.amount} payable`)
});